var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStageProgressAppLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 30,
    viewBox: "0 0 23 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8895_3049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.833 0.304688V18.1213C21.833 24.0661 17.0137 28.8854 11.0689 28.8854C5.12398 28.8854 0.304688 24.0661 0.304688 18.1213V0.304688H21.833Z",
    stroke: "#1C1C1E",
    strokeWidth: 0.618631
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3031 1.69141V18.3095C20.3031 23.3876 16.1866 27.5041 11.1086 27.5041C6.03061 27.5041 1.91406 23.3876 1.91406 18.3095V1.69141H20.3031Z",
    stroke: "#1C1C1E",
    strokeWidth: 0.558715
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.33203 20.2773H20.0956",
    stroke: "#1C1C1E",
    strokeWidth: 0.618631
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.03906 9.43359H20.1031",
    stroke: "#1C1C1E",
    strokeWidth: 0.618631
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.10938 24.0523L9.12912 20.5703L11.0999 21.9048L12.3902 20.5703L17.8518 24.2026",
    stroke: "#1C1C1E",
    strokeWidth: 0.618631
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14844 23.9336C8.55361 24.9764 11.3375 26.2667 15.1288 23.9513",
    stroke: "#1C1C1E",
    strokeWidth: 0.618631
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1211 10.7617V18.3797H15.7785",
    stroke: "#1C1C1E",
    strokeWidth: 0.618631
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1211 1.83203V9.45003",
    stroke: "#1C1C1E",
    strokeWidth: 0.618631
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.48062 12.9688C7.85768 13.3635 8.11733 14.2025 7.34805 15.293C6.64985 16.2828 7.97549 16.8131 7.97549 17.6969C7.97551 18.3508 7.17127 18.5276 7.06525 19.3318C6.98267 19.9582 7.27735 20.1655 7.34805 20.2244",
    stroke: "#1C1C1E",
    strokeWidth: 0.618631
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.22893 14.8164C5.71823 15.3555 5.66519 15.603 5.13492 16.4779C4.50709 17.5137 5.6298 17.4677 5.62982 18.3514C5.62982 19.0054 4.3805 19.3589 5.22893 20.3929",
    stroke: "#1C1C1E",
    strokeWidth: 0.618631
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9453 12.9558C13.3401 12.5787 14.179 12.3191 15.2696 13.0884C16.2594 13.7866 16.7897 12.4609 17.6734 12.4609C18.3274 12.4609 18.5041 13.2652 19.3084 13.3712C19.9348 13.4538 20.1421 13.1591 20.2009 13.0884",
    stroke: "#1C1C1E",
    strokeWidth: 0.618631
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8203 15.1978C15.3594 14.7085 15.6069 14.7615 16.4818 15.2918C17.5176 15.9196 17.4716 14.7969 18.3553 14.7969C19.0093 14.7969 19.3628 16.0462 20.3968 15.1978",
    stroke: "#1C1C1E",
    strokeWidth: 0.618631
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2734 3.85254C16.1626 3.85254 16.9019 4.49314 17.0557 5.33789L17.0166 5.3457H18.0488V5.94727H17.0713V5.90039L17.0625 5.9541C16.9236 6.81671 16.1752 7.47559 15.2734 7.47559C14.273 7.47546 13.4619 6.66456 13.4619 5.66406C13.462 4.66367 14.273 3.85266 15.2734 3.85254ZM15.2734 4.45312C14.6049 4.45325 14.0626 4.99557 14.0625 5.66406C14.0625 6.33266 14.6049 6.87488 15.2734 6.875C15.9421 6.875 16.4844 6.33273 16.4844 5.66406C16.4843 4.9955 15.942 4.45312 15.2734 4.45312Z",
    fill: "#1C1C1E",
    stroke: "#1C1C1E",
    strokeWidth: 0.0176752
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.87705 9.41055C9.53239 7.9877 8.00348 6.84766 6.43039 6.84766C4.85731 6.84766 3.42562 7.76676 2.92188 9.41055",
    stroke: "#1C1C1E",
    strokeWidth: 0.618631
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.03906 4.78597C3.12197 3.80581 4.7393 3.18359 6.54623 3.18359C8.35316 3.18359 9.97049 3.80581 11.0534 4.78597",
    stroke: "#1C1C1E",
    strokeWidth: 0.618631
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.03906 1.74609L4.00236 3.78758M6.37967 1.74609V3.32802M9.88819 1.74609L8.89838 3.78758",
    stroke: "#1C1C1E",
    strokeWidth: 0.618631
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8895_3049"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.147,
    height: 29.1994,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStageProgressAppLogo);
export default __webpack_public_path__ + "static/media/stage-progress-app-logo.92837e5f7bbc41ec61859dabee0aca7c.svg";
export { ForwardRef as ReactComponent };